export enum UPSALE {
  MAIN = '/upsale',
  SKIP_TRIAL = '/upsale/screens/skip-trial',
  ADD_PACKS = '/upsale/screens/add-packs',
  EARLY_ACCESS = '/upsale/screens/early_access',
  DETAILED_REPORT = '/upsale/screens/detailed-report',
  OFFLINE_MODE = '/upsale/screens/offline-mode',
  DAYS_PLAN = '/upsale/screens/days-plan',
  ASSISTANT = '/upsale/screens/assistant',
  PREGNANCY_EBOOK = '/upsale/screens/pregnancy-ebook',
  MEDITATION_EBOOK = '/upsale/screens/meditation-ebook',
  MEGA_PACK = '/upsale/screens/mega-pack',
  BIG_UPSALE = '/upsale/screens/big-upsale',
  FULL_AI_MASTER_PACK = '/upsale/screens/full-ai-master-pack',
  AI_SIDE_HUSTLE_PLAN = '/upsale/screens/ai-side-hustle-plan',
  MULTI_UPSALE = '/upsale/screens/multi-upsale',
  IG_GROWTH_COURSE = '/upsale/screens/ig-growth-course',
  IG_FOLLOWERS_PACK = '/upsale/screens/ig-followers-pack',
}

export type ListItem = {
  icon: string;
  text: string;
};

export type SuccessMessageType = {
  emoji: string;
  title: string;
  message: string;
};

export enum UPSALE_NAMES {
  SKIP_TRIAL = 'skipTrial',
  ULTRA_PACK = 'ultraPack',
  EARLY_ACCESS = 'earlyAccess',
  DETAILED_REPORT = 'detailedReport',
  OFFLINE_MODE = 'offlineAccess',
  DAYS_PLAN = 'daysPlan',
  ASSISTANT = 'ASSISTANT',
  PREGNANCY_EBOOK = 'pregnancyEbook',
  MEDITATION_EBOOK = 'meditationEbook',
  MEGA_PACK = 'megaPack',
  BIG_UPSALE = 'bigUpsale',
  BIG_UPSALE_DISCOUNT = 'bigUpsaleDiscount',
  FULL_AI_MASTER_PACK = 'fullAiMasterPack',
  AI_SIDE_HUSTLE_PLAN = 'aiSideHustlePlan',
  FULL_AI_MASTER_PACK_SPECIAL = 'fullAiMasterPackSpecial',
  AI_SIDE_HUSTLE_PLAN_SPECIAL = 'aiSideHustlePlanSpecial',
  RARE_INTELLIGENCE_PLAN = 'rareIntelligencePlan',
  ULTRA_PACK_SPECIAL = 'ultraPackSpecial',
  RARE_INTELLIGENCE_PLAN_SPECIAL = 'rareIntelligencePlanSpecial',
  COOKING_NUTRITION = 'cookingNutrition',
  COOKING_NUTRITION_SPECIAL = 'cookingNutritionSpecial',
  MULTI_UPSALE = 'multiUpsale',
  IG_FOLLOWERS_PACK_SPECIAL = 'igFollowersPackSpecial',
  IG_GROWTH_COURSE_SPECIAL = 'igGrowthCourseSpecial',
  IG_FOLLOWERS_PACK = 'igFollowersPack',
  IG_GROWTH_COURSE = 'igGrowthCourse',
}
